import React, { useEffect, useState } from 'react';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Text } from 'apps/auth/components/common/Text/Text';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const AppInboxModal = ({ modalRef, cards }) => {
    const { notifications, dayAgo, daysAgo, caughtUp, today } = usePageMessages();
    const [noCards, setNoCards] = useState(false);

    useEffect(() => {
        if (typeof braze !== 'undefined') {
            const container = document.getElementById('content-cards');
            if (!container) return;
            if (!cards?.length) {
                setNoCards(true);
                return;
            }
            setNoCards(false);
            braze.showContentCards(container);

            cards.forEach((card) => {
                const cardEl = document.querySelector(`[data-ab-card-id="${card.id}"]`);
                const isPinned = card.pinned;
                const unreadEl = cardEl?.querySelector('.ab-unread-indicator');

                if (isPinned && unreadEl) unreadEl.style.display = 'none';

                if (cardEl && !cardEl.querySelector('.ab-card-date')) {
                    const dateEl = document.createElement('div');
                    const createdDate = new Date(card.created);
                    const todayDate = new Date();
                    const daysAgoNumber = Math.floor((todayDate - createdDate) / (1000 * 60 * 60 * 24));
                    const label = daysAgoNumber === 0 ? today : resolveArguments(daysAgoNumber === 1 ? dayAgo : daysAgo, daysAgoNumber);

                    dateEl.className = 'ab-card-date';
                    dateEl.textContent = label;
                    const body = cardEl.querySelector('.ab-card-body');
                    if (body) {
                        body.insertBefore(dateEl, body.firstChild);
                    }
                }
            });
        }
    }, [cards]);

    return (
        <ModalComponent modalRef={modalRef} isIconClose>
            <HeaderPanel title={notifications} />
            {noCards ? (
                <Text color="lightGray" variant={'div'} textAlign={'center'}>
                    {caughtUp}
                </Text>
            ) : (
                <>
                    <div id="content-cards" />
                    <Text color="lightGray" variant={'div'} textAlign={'center'}>
                        {caughtUp}
                    </Text>
                </>
            )}
        </ModalComponent>
    );
};

export default AppInboxModal;
